// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"12589":"b381f555","40453":"48f159c8","62944":"8162130a","91164":"c5fb31d6","92781":"d7620599"}[chunkId] + ".css";
};